export default "__VITE_ASSET__DCWEtJyP__"